export const cleaner = (value = '') => {
    if (value == 'undefined' || value == 'null') {
        return ''
    }
    return value;
}